import React from 'react'
import styles from './updating-overlay.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import Spinner from 'pobble-components/dist/spinner'

const UpdatingOverlay = ({ classes, className }) => (
  <div className={classNames(classes.container, className)}>
    <Spinner />
  </div>
)

export default injectSheet(styles)(UpdatingOverlay)
